import { render } from "./WSubTitle.vue?vue&type=template&id=4ac432f7&ts=true"
import script from "./WSubTitle.vue?vue&type=script&lang=ts"
export * from "./WSubTitle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__